import { LoadingDropdownData } from 'app/viewmodels/form-controls/loading-dropdown-data';
import { Subject } from 'rxjs';
import { LoadingDropdownSettings } from './event-emitter-entities/loading-more-settings';
import { FormControlBase } from './form-control-base';
import { FormMultiSelectControlData } from './form-control-data';

export class MultiSelectControl extends FormControlBase<any> {
  controlType = 'multi-select';
  selectedOptions: any;
  optionLabel: string;
  optionValue: string;
  selectedOptionsProperty: string;

  loading = false;
  loadItemsRequest = new Subject<LoadingDropdownSettings>();

  constructor(options: FormMultiSelectControlData<any>) {
    super(options);
    this.selectedOptions = options.selectedOptions;
    this.optionLabel = options.optionLabel || '';
    this.optionValue = options.optionValue || '';
    this.selectedOptionsProperty = options.selectedOptionsProperty;
  }

  protected initialize() {}

  commit() {}

  addOptions(data: LoadingDropdownData, settings: LoadingDropdownSettings): void {
    if (settings.startItemNumber === 0) {
      this.options = data.anyValues;
    } else {
      this.options = this.options.concat(data.anyValues);
    }
  }

  requestLoadItems(settings: LoadingDropdownSettings): void {
    this.loading = true;
    this.loadItemsRequest.next(settings);
  }
}
